export interface EmailAttachmentInput {
  name: string
  content: string
  content_type: string
}

export interface AttachedFile {
  file: File
  id: string
}

export function data_url_to_base64(data_url: string): string {
  return data_url.split(",", 2)[1] ?? ""
}

export function file_to_base64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(data_url_to_base64(reader.result as string))
    reader.onerror = error => reject(error)
  })
}

export async function files_to_attachment_inputs(files: AttachedFile[]): Promise<EmailAttachmentInput[]> {
  return Promise.all(
    files.map(async ({ file }: AttachedFile) => ({
      name: file.name,
      content: await file_to_base64(file),
      content_type: file.type || "application/octet-stream",
    }))
  )
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("data_url_to_base64", () => {
    it("strips the data URL prefix", () => {
      expect(data_url_to_base64("data:application/pdf;base64,abc123")).toBe("abc123")
    })

    it("returns an empty string for malformed data URLs", () => {
      expect(data_url_to_base64("abc123")).toBe("")
    })
  })
}
